import { V as e, T as r, P as F, O as l, d as g, L as n, C, c as a, A as E } from "../../../../brands-CoixlYYY.js";
const o = {
  black: "#000000",
  grey50: "#F5F5F2",
  grey100: "#E3E3E0",
  grey200: "#CECECB",
  grey300: "#A6A6A3",
  grey500: "#6E6E6B",
  grey600: "#595956",
  transparent: "transparent",
  white: "#FFFFFF"
}, t = {
  blue550: "#0d74af",
  blue650: "#004977",
  blue700: "#273b49",
  blue750: "#1C2640",
  green650: "#008140",
  green700: "#128020",
  grey50: "#eeeeee",
  grey150: "#cfcccf",
  grey250: "#aeb5bb",
  grey500: "#677580",
  grey650: "#3e464d",
  grey800: "#011728",
  orange500: "#EF5600",
  red550: "#d03027",
  red650: "#a82418",
  teal450: "#00C3B3"
}, y = {
  blue750: "#1C2640",
  green450: "#26E066",
  green650: "#008044",
  grey50: "#F5F5F2",
  grey750: "#2D2D2D",
  grey850: "#0E0F0F",
  orange500: "#FA5600",
  pink200: "#F799BA",
  purple350: "#8E3DFF",
  red550: "#CC2427",
  red600: "#E00029"
}, B = {
  blue700: "#27314a",
  blue750: "#1C2640",
  green650: "#008140",
  orange500: "#FA5600",
  pink250: "#FF8791",
  red500: "#EB3C32",
  red550: "#CC2427",
  teal450: "#00C3B3",
  teal600: "#007B90",
  yellow250: "#FFE433"
}, A = {
  blue750: "#1C2640",
  green600: "#579D0A",
  green650: "#008140",
  grey100: "#E1E1E1",
  grey50: "#F6F6F6",
  grey700: "#30383B",
  purple550: "#7C2582",
  orange500: "#FA5600",
  red550: "#CC2427",
  red600: "#EB0029",
  teal500: "#00ADBB",
  teal600: "#007B90",
  yellow400: "#EBB819"
}, s = {
  blue750: "#1C2640",
  green650: "#008140",
  grey850: "#070517",
  purple500: "#615693",
  purple700: "#2A2550",
  orange500: "#FA5600",
  red550: "#CC2427",
  teal450: "#00C3B3",
  teal600: "#007B90",
  pink250: "#FF8791",
  yellow250: "#FFE433"
}, u = {
  blue100: "#CCEFFF",
  blue450: "#3D6BEB",
  blue750: "#1C2640",
  blue800: "#000D5C",
  green650: "#008140",
  green500: "#349702",
  grey50: "#EEEEEE",
  orange450: "#E56A2D",
  pink350: "#FC6965",
  red550: "#CC2427",
  yellow300: "#FFCB24",
  teal450: "#00C3B3",
  teal600: "#007B90"
}, b = {
  blue750: "#1C2640",
  green500: "#76C51F",
  green650: "#008140",
  grey150: "#CECFCD",
  grey50: "#F9F9F9",
  grey600: "#58595B",
  grey700: "#333333",
  orange500: "#FA5600",
  pink250: "#FF8791",
  red549: "#D71440",
  red550: "#CC2427",
  red600: "#A81032",
  teal450: "#00C3B3",
  teal600: "#007B90",
  yellow250: "#FFE433"
}, p = {
  blue400: "#24ABE0",
  blue550: "#0078B2",
  blue750: "#1C2640",
  green500: "#349702",
  green600: "#46A900",
  green650: "#008140",
  grey100: "#E3E3E0",
  grey200: "#CECECB",
  grey300: "#A6A6A3",
  grey500: "#6E6E6B",
  grey50: "#F5F5F2",
  purple400: "#7060EB",
  orange500: "#FA5600",
  red550: "#CC2427",
  red650: "#D10000",
  teal600: "#007B90",
  yellow250: "#FFE433"
}, d = {
  blue600: "#006699",
  blue750: "#1C2640",
  green600: "#579D0A",
  green650: "#008140",
  grey350: "#9D9D9D",
  pink250: "#FF8791",
  pink500: "#DE007B",
  orange500: "#FA5600",
  red550: "#CC2427",
  teal450: "#00C3B3",
  teal600: "#007B90",
  yellow250: "#FFE433"
}, D = {
  [E]: t,
  [a]: y,
  [C]: B,
  [n]: A,
  [g]: s,
  [l]: u,
  [F]: b,
  [r]: p,
  [e]: d,
  global: o
};
export {
  D as default
};
